import { NavItem } from "@/components/atoms/Items/NavItem";
import * as S from "./NavBar.style";

interface NavBarProps {
  menu?: any;
  setLearningPwModal?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const NavBar = ({ menu, setLearningPwModal }: NavBarProps) => {
  return (
    <S.NavBar>
      <S.NavList>
        {menu.map((item: any, idx: number) => {
          return (
            <NavItem
              data={item}
              key={idx}
              setLearningPwModal={setLearningPwModal}
            />
          );
        })}
      </S.NavList>
    </S.NavBar>
  );
};
